module.exports = __webpack_public_path__ + "static/img/MICROFIBER PU products discription_deskstop.8fb2e5d5.jpg";